import { render } from "./subscriptionplan.vue?vue&type=template&id=09d2dcc2&scoped=true"
import script from "./subscriptionplan.vue?vue&type=script&lang=js"
export * from "./subscriptionplan.vue?vue&type=script&lang=js"

import "./subscriptionplan.vue?vue&type=style&index=0&id=09d2dcc2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d2dcc2"]])

export default __exports__